
// @ts-nocheck


export const localeCodes =  [
  "en",
  "zh",
  "ja",
  "zh-TW",
  "ko",
  "hi",
  "de",
  "ar",
  "fr",
  "id",
  "itb",
  "uk"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46ts_cd6269ca",
      load: () => import("#nuxt-i18n/cd6269ca" /* webpackChunkName: "locale_en_46ts_cd6269ca" */),
      cache: false
    }
  ],
  zh: [
    {
      key: "locale_zh_45CN_46ts_1ce66050",
      load: () => import("#nuxt-i18n/1ce66050" /* webpackChunkName: "locale_zh_45CN_46ts_1ce66050" */),
      cache: false
    }
  ],
  ja: [
    {
      key: "locale_ja_46ts_8e23cb4d",
      load: () => import("#nuxt-i18n/8e23cb4d" /* webpackChunkName: "locale_ja_46ts_8e23cb4d" */),
      cache: false
    }
  ],
  "zh-TW": [
    {
      key: "locale_zh_45TW_46ts_da6dd8f4",
      load: () => import("#nuxt-i18n/da6dd8f4" /* webpackChunkName: "locale_zh_45TW_46ts_da6dd8f4" */),
      cache: false
    }
  ],
  ko: [
    {
      key: "locale_ko_46ts_21d966a3",
      load: () => import("#nuxt-i18n/21d966a3" /* webpackChunkName: "locale_ko_46ts_21d966a3" */),
      cache: false
    }
  ],
  hi: [
    {
      key: "locale_hi_46ts_78c1168a",
      load: () => import("#nuxt-i18n/78c1168a" /* webpackChunkName: "locale_hi_46ts_78c1168a" */),
      cache: false
    }
  ],
  de: [
    {
      key: "locale_de_46ts_97911c39",
      load: () => import("#nuxt-i18n/97911c39" /* webpackChunkName: "locale_de_46ts_97911c39" */),
      cache: false
    }
  ],
  ar: [
    {
      key: "locale_ar_46ts_4c030c9c",
      load: () => import("#nuxt-i18n/4c030c9c" /* webpackChunkName: "locale_ar_46ts_4c030c9c" */),
      cache: false
    }
  ],
  fr: [
    {
      key: "locale_fr_46ts_956cf8e0",
      load: () => import("#nuxt-i18n/956cf8e0" /* webpackChunkName: "locale_fr_46ts_956cf8e0" */),
      cache: false
    }
  ],
  id: [
    {
      key: "locale_id_46ts_90bf44e8",
      load: () => import("#nuxt-i18n/90bf44e8" /* webpackChunkName: "locale_id_46ts_90bf44e8" */),
      cache: false
    }
  ],
  itb: [
    {
      key: "locale_it_46ts_6d04ac71",
      load: () => import("#nuxt-i18n/6d04ac71" /* webpackChunkName: "locale_it_46ts_6d04ac71" */),
      cache: false
    }
  ],
  uk: [
    {
      key: "locale_uk_46ts_e45cd251",
      load: () => import("#nuxt-i18n/e45cd251" /* webpackChunkName: "locale_uk_46ts_e45cd251" */),
      cache: false
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      iso: "en-US",
      name: "English",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/en.ts"
      ]
    },
    {
      code: "zh",
      iso: "zh-CN",
      name: "简体中文",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/zh-CN.ts"
      ]
    },
    {
      code: "ja",
      iso: "ja-JP",
      name: "日文",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/ja.ts"
      ]
    },
    {
      code: "zh-TW",
      iso: "zh-TW",
      name: "繁体中文",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/zh-TW.ts"
      ]
    },
    {
      code: "ko",
      iso: "ko-KR",
      name: "한국어",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/ko.ts"
      ]
    },
    {
      code: "hi",
      iso: "hi-IN",
      name: "印地语",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/hi.ts"
      ]
    },
    {
      code: "de",
      iso: "de-DE",
      name: "德语",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/de.ts"
      ]
    },
    {
      code: "ar",
      iso: "ar-AE",
      name: "阿拉伯语",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/ar.ts"
      ]
    },
    {
      code: "fr",
      iso: "fr-FR",
      name: "法语",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/fr.ts"
      ]
    },
    {
      code: "id",
      iso: "id-ID",
      name: "印尼语",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/id.ts"
      ]
    },
    {
      code: "itb",
      iso: "it-IT",
      name: "意大利语",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/it.ts"
      ]
    },
    {
      code: "uk",
      iso: "uk-UA",
      name: "乌克兰语",
      dir: "auto",
      files: [
        "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/uk.ts"
      ]
    }
  ],
  defaultLocale: "",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "en",
    redirectOn: "no prefix",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    iso: "en-US",
    name: "English",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/en.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "zh",
    iso: "zh-CN",
    name: "简体中文",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/zh-CN.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "ja",
    iso: "ja-JP",
    name: "日文",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/ja.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "zh-TW",
    iso: "zh-TW",
    name: "繁体中文",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/zh-TW.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "ko",
    iso: "ko-KR",
    name: "한국어",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/ko.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "hi",
    iso: "hi-IN",
    name: "印地语",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/hi.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    iso: "de-DE",
    name: "德语",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/de.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "ar",
    iso: "ar-AE",
    name: "阿拉伯语",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/ar.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    iso: "fr-FR",
    name: "法语",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/fr.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "id",
    iso: "id-ID",
    name: "印尼语",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/id.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "itb",
    iso: "it-IT",
    name: "意大利语",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/it.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "uk",
    iso: "uk-UA",
    name: "乌克兰语",
    dir: "auto",
    files: [
      {
        path: "/var/jenkins_home/workspace/pdf_web_biz_cn/i18n/locales/uk.ts",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/